

import Component from "vue-class-component";
import { InjectReactive } from "vue-property-decorator";
import { printCost } from "@/lib/moneyHelpers";
import Original from "@/components/CallController/components/VideoRequestConfirm/VideoRequestConfirm.ts";
import { CallPrices } from "@/plugins/paidCalls/components/PaidCallController/PaidCallController.vue";

@Component({ name: "VideoRequestConfirm" })
export default class VideoRequestConfirm extends Original {
  @InjectReactive({ from: "callPriceToProvide", default: () => ({ videoCallPrice: 0 }) })
  public readonly callPrices!: CallPrices;

  public get price() {
    return this.callPrices.videoCallPrice > 0 && this.callerId !== this.opponentUser.id
      ? printCost(this.callPrices.videoCallPrice)
      : "";
  }
}
